import { SectionTitle } from '../../ui';
import { ServiceCard } from './ServiceCard';
import { AdditionalServiceCard } from './AdditionalServiceCard';
import { services, additionalServices } from '../../../data';

export function Services() {
    return (
        <section className="py-12 md:py-16 bg-main-color">
            <div className="container mx-auto px-4 max-w-[1240px]">
                <SectionTitle subtitle="Negocierea si incheierea politelor de asigurare cu cele mai puternice societati" className="text-white [&>h2]:text-white [&>p]:text-white/80">
                    Produsele & Serviciile noastre
                </SectionTitle>

                {/* Services Grid */}
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mb-12">
                    {services.map((service) => (
                        <ServiceCard key={service.id} service={service} />
                    ))}
                </div>

                {/* Additional Services */}
                <div className="max-w-4xl mx-auto">
                    <h3 className="font-font-s text-xl font-bold text-center text-white mb-6">
                        Servicii aditionale incluse
                    </h3>
                    <div className="grid md:grid-cols-1 gap-4">
                        {additionalServices.map((service) => (
                            <AdditionalServiceCard key={service.id} service={service} />
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
